import React, { createContext, useContext, useState, ReactNode } from 'react';

interface GlobalLoaderContextType {
  isLoading: boolean;
  // Optional narration shown under the spinner. Long waits (the AI proof check
  // can run for a minute) read as a frozen page behind a bare spinner.
  message: string;
  showLoader: (message?: string) => void;
  setLoaderMessage: (message: string) => void;
  hideLoader: () => void;
}

const GlobalLoaderContext = createContext<GlobalLoaderContextType | undefined>(undefined);

export const GlobalLoaderProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState('');

  const showLoader = (nextMessage = '') => {
    setMessage(nextMessage);
    setIsLoading(true);
  };
  const setLoaderMessage = (nextMessage: string) => setMessage(nextMessage);
  const hideLoader = () => {
    setIsLoading(false);
    setMessage('');
  };

  return (
    <GlobalLoaderContext.Provider
      value={{ isLoading, message, showLoader, setLoaderMessage, hideLoader }}
    >
      {children}
    </GlobalLoaderContext.Provider>
  );
};

export const useGlobalLoader = () => {
  const context = useContext(GlobalLoaderContext);
  if (!context) {
    throw new Error('useGlobalLoader must be used within a GlobalLoaderProvider');
  }
  return context;
};
